module.exports = __webpack_public_path__ + "static/media/ic_thumb_down_24px.01a47f2d.svg";